<button #trigger="cdkOverlayOrigin" (click)="triggerNotificationOverlay($event)" cdkOverlayOrigin mat-icon-button
matTooltip="Benachrichtigungen">
    <mat-icon [matBadgeHidden]="unread <= 0" [matBadge]="unread" matBadgeColor="accent">notifications</mat-icon>
</button>

<ng-template
    [cdkConnectedOverlayOpen]="opened"
    [cdkConnectedOverlayOrigin]="trigger"
    [cdkConnectedOverlayPositions]="positionPairs"
    cdkConnectedOverlay
>
    <div class="container-overlay">
        <h1 class="headline">Benachrichtigungen</h1>
        <mat-tab-group #matTabGroup>
            <mat-tab label="Nachrichten">
                <phito-notification-overview-list [notifications]="notifications"></phito-notification-overview-list>
            </mat-tab>
            <mat-tab label="Einstellungen">
                <phito-notification-settings-list></phito-notification-settings-list>
            </mat-tab>
        </mat-tab-group>
    </div>
</ng-template>
